// extracted by mini-css-extract-plugin
export default {"wrapper":"xiD0e","image":"ba6H9","image-default":"xsb12","image-mobile":"xBqvC","title":"fQGSP","description":"quSIH"};